// @flow

import * as React from "react";
import moment from "moment";

import type { TaskType } from "../../data/tasks";

import "./task.css";

const PolitifactDate = (props: { date: ?string }) => {
  const date = props.date
    ? moment(props.date).format("MMMM Do, YYYY")
    : "unknown date";
  return <span className="PolitifactDate">{date}</span>;
};

const PolitifactSpeaker = (props: { speaker: ?string, job: ?string }) => {
  const speaker = props.speaker || "Unknown speaker";
  return (
    <span className="PolitifactSpeaker">
      <span className="PolitifactSpeaker-Name">{speaker}</span>
      {props.job ? ` (${props.job})` : ""}
    </span>
  );
};

const extraFields = [
  { title: "Context", name: "context" },
  { title: "Speaker's state", name: "state" },
  { title: "Speaker's party", name: "party" },
  { title: "Topics", name: "subject" }
];

const task = {
  prompt: "How likely is it that this statement is true (in %)?",
  confidenceLabels: {
    left: "Definitely false",
    middle: "No idea",
    right: "Definitely true"
  },
  answerText: {
    false: "It is false.",
    true: "It is true."
  },
  renderQuestion(task: TaskType) {
    return (
      <div className="Politifact-Container">
        <div className="Politifact-Preamble">
          <PolitifactSpeaker
            speaker={task.metadata.speaker}
            job={task.metadata.job}
          />{" "}
          on <PolitifactDate date={task.metadata.date} />:
        </div>
        <div className="Politifact-Statement">{task.question}</div>
        <div className="Politifact-Extra">
          {extraFields.map(field => {
            const value = task.metadata[field.name];
            if (value) {
              return (
                <div className="Politifact-Extra-Field" key={field.name}>
                  <span className="Politifact-Extra-Title">
                    {field.title}
                  </span>{" "}
                  <span className="Politifact-Extra-Value">{value}</span>
                </div>
              );
            } else {
              return null;
            }
          })}
        </div>
      </div>
    );
  },
  tools: {
    wikipedia: false,
    google: true
  }
};

export default task;



// WEBPACK FOOTER //
// ./src/templates/politifact/task.js